import React from "react";

//React Icons
import {RiLogoutBoxRLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.svg";
import HomeIconFilled from "../assets/home-icon-yellow.svg";
import HomeIcon from "../assets/home-icon-white.svg";
import TransferIconFilled from "../assets/transfer-icon-yellow.svg";
import TransferIcon from "../assets/transfer-icon-white.svg";

import DropDown from "./DropDown.js";
import MobileNav from "./MobileNav.js";

const Header = (props) => {
  const [navOpen, setNavOpen] = React.useState(false);

  const saved = localStorage.getItem("userDetails");
  const initialValue = JSON.parse(saved);
  const userDetails = initialValue && initialValue.response;

  const handleLogout = () => {
    localStorage.removeItem("userDetails");
    window.location.href = "/";
  };

  return (
    <header className="">
      <nav
        className={`w-full flex flex-row items-center justify-between fixed top-0 shadow-sm bg-[#14141D] backdrop-blur-md z-50 font-poppins h-[80px] border-[1px] border-[#ffffff]/10`}
      >
        <div>
          <span className="flex items-center justify-center py-3 ml-4 md:ml-16">
            <img src={Logo} alt="Logo" width={30} />

            <span className="ml-2 text-base text-[#ffffff]/80 font-semibold   px-3 py-0.5">
              Ansh Fintech
            </span>
          </span>
        </div>

        <div className="pl-12 lg:flex hidden flex-row items-center lg:space-x-4 font-medium text-sm text-gray-900 mr-3">
          <Link
            to="/"
            className={
              window.location.pathname === "/"
                ? "border-b-4 border-[#FEF35A] py-4 flex"
                : "flex"
            }
          >
            <span className={`mx-3 px-3  mt-2 py-2 ${window.location.pathname === "/" ? 'text-[#FEF35A]' : 'text-[#ffffff]/50'} rounded-lg hover:bg-white/10 hover:text-[#FEF35A] hover:scale-110 active:scale-95 ease-linear duration-150 relative hidden lg:flex cursor-pointer gap-2`}
              onMouseEnter={(e) => e.currentTarget.querySelector('img').src = HomeIconFilled}
              onMouseLeave={(e) => e.currentTarget.querySelector('img').src = window.location.pathname === "/" ? HomeIconFilled : HomeIcon}
            >
              <img src={window.location.pathname === "/" ? HomeIconFilled : HomeIcon} alt="Home" />
              Home
            </span>
          </Link>
          <Link
            to="/transfer"
            className={
              window.location.pathname === "/transfer"
                ? "border-b-4 border-[#FEF35A] py-4 flex"
                : "flex"
            }
          >
            <span className={`mx-3 mt-2 px-3 py-2 ${window.location.pathname === "/transfer" ? 'text-[#FEF35A]' : 'text-[#ffffff]/50'} rounded-lg hover:bg-white/10 hover:text-[#FEF35A] hover:scale-110 active:scale-95 ease-linear duration-150 relative hidden lg:flex cursor-pointer gap-2`}
              onMouseEnter={(e) => e.currentTarget.querySelector('img').src = TransferIconFilled}
              onMouseLeave={(e) => e.currentTarget.querySelector('img').src = window.location.pathname === "/transfer" ? TransferIconFilled : TransferIcon}
            >
              <img src={window.location.pathname === "/transfer" ? TransferIconFilled : TransferIcon} alt="transfer" />
              Transfer
            </span>
          </Link>
          {userDetails && userDetails[5] === "TRUE" ? (
            <Link
              to="/admin"
              className={
                window.location.pathname === "/admin"
                  ? "border-b-4 border-[#FFCF2C] py-4"
                  : ""
              }
            >
              <span className={`mx-3 mt-2 px-3 py-2  ${window.location.pathname === "/admin" ? 'text-[#FEF35A]' : 'text-[#ffffff]/50'} rounded-lg hover:bg-white/10 hover:text-neutral-50 hover:scale-110 active:scale-95 ease-linear duration-150 relative hidden lg:flex cursor-pointer`}>
                Admin
              </span>
            </Link>
           ) : null}
        </div>
        <div className="">
          <DropDown user={userDetails && userDetails} />
        </div>
        <div
          onClick={handleLogout}
          className="text-white cursor-pointer mr-4 justify-end flex lg:hidden"
        >
          <RiLogoutBoxRLine size={25} color="#ffffff" />
        </div>
      </nav>
      {navOpen && (
        <MobileNav userDetails={userDetails} setNavOpen={setNavOpen} />
      )}
      <div className="fixed bottom-0 w-full flex justify-around bg-[#14141D] lg:hidden z-[9999]">
        <Link
          to="/"
          className={
            window.location.pathname === "/"
              ? "py-4 flex"
              : "flex"
          }
        >
          <span className={`mx-3 px-3 py-2 ${window.location.pathname === "/" ? 'text-[#FEF35A]' : 'text-[#ffffff]/50'} rounded-lg hover:bg-white/10 hover:text-[#FEF35A] hover:scale-110 active:scale-95 ease-linear duration-150 relative flex cursor-pointer gap-2 items-center`}
            onMouseEnter={(e) => e.currentTarget.querySelector('img').src = HomeIconFilled}
            onMouseLeave={(e) => e.currentTarget.querySelector('img').src = window.location.pathname === "/" ? HomeIconFilled : HomeIcon}
          >
            <img src={window.location.pathname === "/" ? HomeIconFilled : HomeIcon} alt="Home" className="h-6 w-6"/>
            Home
          </span>
        </Link>
        <Link
          to="/transfer"
          className={
            window.location.pathname === "/transfer"
              ? "py-4 flex"
              : "flex"
          }
        >
          <span className={`mx-3 px-3 py-2 ${window.location.pathname === "/transfer" ? 'text-[#FEF35A]' : 'text-[#ffffff]/50'} rounded-lg hover:bg-white/10 hover:text-[#FEF35A] hover:scale-110 active:scale-95 ease-linear duration-150 relative flex cursor-pointer gap-2 items-center`}
            onMouseEnter={(e) => e.currentTarget.querySelector('img').src = TransferIconFilled}
            onMouseLeave={(e) => e.currentTarget.querySelector('img').src = window.location.pathname === "/transfer" ? TransferIconFilled : TransferIcon}
          >
            <img src={window.location.pathname === "/transfer" ? TransferIconFilled : TransferIcon} alt="transfer" className="h-6 w-6" />
            Transfer
          </span>
        </Link>
      </div>
    </header>
  );
};

export default Header;
